import styled from '@emotion/styled'

export const Icon = styled.div`
  div {
    width: 10px;
    height: 10px;
    background-color: #d4d8dd;
  }
`
